"use strict";

document.addEventListener("DOMContentLoaded", function (event) {
  var _document$querySelect;
  (_document$querySelect = document.querySelectorAll('quantity-selector')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.forEach(function (qtySelectors) {
    qtySelectors.querySelectorAll('.quantity-selector__button').forEach(function (button) {
      button.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('variant:qty:change', {
          detail: {
            input: qtySelectors
          }
        }));
      });
    });
  });
  document.addEventListener('theme:quickBuy:end', function (e) {
    var params = e.detail;
    handleSizeToggler();
    if (params.productCard) {
      var productCard = params.productCard;
      var quickHolder = params.quickHolder;
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(swymCallbackFn.bind(productCard));
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      productCard.querySelector('form').addEventListener('variant:change', function (e) {
        // console.log(e)
        // console.log(productCard)
        // console.log('Variant changed', e.detail);
        // console.log(quickHolder.querySelector('.swym-button[data-product-id]'))

        quickHolder.querySelectorAll('.swym-button[data-product-id]').forEach(function (btn) {
          btn.setAttribute('data-variant-id', e.detail.variant.id);
        });
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

        /**
         * SOLD OUT CLASS TOGGLE
         */
        if (!e.detail.variant.available) {
          // e.target closest quick-buy-modal add class sold-out
          if (e.target.closest('.quick-buy-modal')) {
            e.target.closest('.quick-buy-modal').classList.add('sold-out');
          }
          productCard.classList.add('sold-out');
        } else {
          if (e.target.closest('.quick-buy-modal')) {
            e.target.closest('.quick-buy-modal').classList.remove('sold-out');
          }
          productCard.classList.remove('sold-out');
        }
      });
      // productCard.querySelector('form').dispatchEvent(new CustomEvent('variant:change', {detail: {variant: productCard.querySelector('form').querySelector('[name="id"]').value}}));
    }
  });

  document.documentElement.addEventListener('theme:loading:end', function (e) {
    var _e$detail;
    if (e.detail && ((_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.type) == 'size-chart') {
      handleSizeToggler();
    }
  });
  function handleSizeToggler() {
    var sizeTogglers = document.querySelectorAll('[data-size-toggler]:not(.initialized)');
    if (!sizeTogglers.length) return;
    var filterTable = function filterTable(table, filter) {
      // console.log(table, filter)
      table.querySelectorAll('tr td:first-child').forEach(function (rowLable) {
        rowLable.textContent = rowLable.textContent.replace(/cm|inch/g, filter);
      });
      table.querySelectorAll('tr:not(:first-child) td:not(:first-child)').forEach(function (cell) {
        // in case of inch to cm
        if (filter === 'cm') {
          cell.textContent = cell.dataset.cm;
        }
        // in case of cm to inch
        if (filter === 'inch') {
          cell.dataset.cm = cell.textContent;
          cell.textContent = (cell.textContent / 2.54).toFixed(1);
        }
      });
    };
    sizeTogglers.forEach(function (toggler) {
      toggler.addEventListener('click', function (e) {
        var target = e.target;
        var targetParent = target.parentElement;
        if (!target.dataset.sizeToggle || targetParent.classList.contains('active')) return;
        if (target.dataset.sizeToggle === 'cm') {
          var _targetParent$nextEle;
          filterTable(toggler.nextElementSibling, 'cm');
          targetParent.classList.add('active');
          (_targetParent$nextEle = targetParent.nextElementSibling) === null || _targetParent$nextEle === void 0 ? void 0 : _targetParent$nextEle.classList.remove('active');
        }
        ;
        if (target.dataset.sizeToggle === 'inch') {
          var _targetParent$previou;
          filterTable(toggler.nextElementSibling, 'inch');
          targetParent.classList.add('active');
          (_targetParent$previou = targetParent.previousElementSibling) === null || _targetParent$previou === void 0 ? void 0 : _targetParent$previou.classList.remove('active');
        }
      });
      toggler.classList.add('initialized');
    });
  }

  // Initially running code
  var initialCode = function () {
    handleSizeToggler();
  }();

  /**
   * SWYM custom buttons for quick view
   */
  function swymCallbackFn(swat) {
    var productCard = this;
    // your API calls go here
    attachNotifyMeEvents();
    function attachNotifyMeEvents() {
      var swymNotifyMeBtn = productCard.querySelectorAll(".swym-custom-watchlist");
      swymNotifyMeBtn.forEach(function (btn) {
        btn.addEventListener("click", addToWatchlist);
        btn.classList.add("swym-loaded");
      });
    }
    function addToWatchlist(eventObj) {
      eventObj.preventDefault();
      var productId = +eventObj.target.getAttribute("data-product-id");
      var variantId = +eventObj.target.getAttribute("data-variant-id");
      var du = eventObj.target.getAttribute("data-url");
      var params = {
        empi: productId,
        epi: variantId,
        du: du
      };
      swat.getProductDetails(params, function (productJSON) {
        productJSON.variants.forEach(function (v) {
          if (v.id == variantId) {
            params.pr = SwymUtils.formatProductPrice(v.price);
            params.iu = productJSON.featured_image;
            params.et = 8;
            swat.addToWatchList(eventObj, params, function (e) {
              // console.log("Subscribed to product!", e);
            }); // Shows Subscribe me.
            return;
          }
        });
      });
    }
    document.addEventListener("swym:collections-loaded", function () {
      swat.initializeActionButtons(".product-card__quick-buy[handle=\"".concat(productCard.getAttribute('handle'), "\"]"));
    });
  }
  document.querySelectorAll('.js-marquee').forEach(function (e) {
    var letter = e.querySelector('span');
    // var spanWidth = letter.offsetWidth;
    // e.style.setProperty('--running-move-final', `calc(-${spanWidth * 2}px + var(--running-offset))`);

    for (var counter = 1; counter <= 9; ++counter) {
      var clone = letter.cloneNode(true);
      letter.after(clone);
    }
  });

  //Executed after SWYM has loaded all necessary resources.
  function onSwymLoadCallback(swat) {
    // Please make all SWYM-related API calls inside this function.
    // You can use the swat argument within this scope.
    if (swat) {
      window._swat.evtLayer.addEventListener('sw:addedtocart', function () {
        document.dispatchEvent(new Event('cart:refresh'));
      });
    }
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadCallback);

  // Handle Shipping prices conversion
  var productPageInfo = document.querySelector('.product-info');
  if (productPageInfo && Shopify.currency) {
    productPageInfo.querySelectorAll("[data-converted='false']").forEach(function (el) {
      // input will be like 1000.00 USD
      var input = el.textContent;
      // keep only number
      var price = input.replace(/[^0-9.]/g, "");
      // convert to new currency
      var convertedPrice = price * parseFloat(Shopify.currency.rate);
      // console.log(convertedPrice);
      // el.textContent = Math.round(convertedPrice / 100) * 100 + ' ' + Shopify.currency.active;
      el.textContent = Math.ceil(convertedPrice) + ' ' + Shopify.currency.active;
      el.setAttribute('data-converted', true);
    });
  }
  if (window.location.href.includes("/products/")) {
    var rating = document.querySelector('.product-info__block-item[data-block-type="rating"]');
    rating === null || rating === void 0 ? void 0 : rating.addEventListener('click', function () {
      // add open tag
      var accordion = document.querySelector('#yotpo-reviews-main-widget').closest('.accordion');
      if (!accordion) return;
      accordion.setAttribute('open', '');
      accordion.setAttribute('arial-expanded', 'true');
      accordion.scrollIntoView({
        behavior: "smooth"
      });
    });
    var hemmingCheckbox = document.getElementById('hemming-checkbox');
    hemmingCheckbox === null || hemmingCheckbox === void 0 ? void 0 : hemmingCheckbox.addEventListener('change', function () {
      // Toggle the visibility of the variant picker based on the checkbox status
      hemmingCheckbox.closest("[data-block-type=\"bundled-product\"]").classList.toggle('show-variant-picker', this.checked);
    });
  }
});